import Swiper from "swiper/dist/js/swiper";
function setLastSlide() {
    let container = this.$el[0];
    let visibleSlides = Array.from(container.querySelectorAll(".swiper-slide-visible"));
    let lastSlide = visibleSlides[visibleSlides.length - 1];
    if (visibleSlides && lastSlide) {
        visibleSlides.forEach(visibleSlide => {
            visibleSlide.classList.remove("swiper-slide-last");
        });
        lastSlide.classList.add("swiper-slide-last");
    }
}

function debounce(callback, wait, immediate = false) {
    let timeout = null;

    return function() {
        const callNow = immediate && !timeout;
        const next = () => callback.apply(this, arguments);

        clearTimeout(timeout);
        timeout = setTimeout(next, wait);

        if (callNow) {
            next();
        }
    };
}

function setNextPosition(parent, selector) {
    if (parent) {
        let next = parent.querySelector(".swiper-button-next");
        let img = parent.querySelector(selector);

        next.style.backgroundPositionY = `${img.height / 2}px`;
    }
}

export default function() {
    const categorySwiperElement = document.querySelector(".categories .swiper-container");
    const storySwiperElement = document.querySelector(".stories .swiper-container");
    const instagramSwiperElement = document.querySelector(".instagram .swiper-container");
    const storyDetailSwiperElement = document.querySelector(
        ".story-content__slider .swiper-container"
    );
    const aboutSwiperElement = document.querySelector(".about-content__slider .swiper-container");
    const productGallerySwiperElement = document.querySelector(
        ".product-gallery .swiper-container"
    );
    const relatedProductsSwiperElement = document.querySelector(
        ".product-related .swiper-container"
    );

    const swiperEvents = {
        resize: setLastSlide,
        slideChange: setLastSlide
    };

    let categorySwiper = new Swiper(categorySwiperElement, {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 24,
        navigation: {
            nextEl: ".swiper-button-next"
        },
        watchSlidesVisibility: true,
        breakpointsInverse: true,
        on: swiperEvents
    });

    let storySwiper = new Swiper(storySwiperElement, {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 60,
        navigation: {
            nextEl: ".swiper-button-next"
        },
        watchSlidesVisibility: true,
        breakpointsInverse: true,
        on: {
            resize: setLastSlide,
            slideChange: setLastSlide,
            init: setNextPosition(storySwiperElement, ".story-card__media img")
        }
    });

    // Debounced resize event for positioning swiper next button

    window.addEventListener(
        "resize",
        debounce(() => {
            setNextPosition(storySwiperElement, ".story-card__media img");
        }, 100)
    );

    let instagramSwiper = new Swiper(instagramSwiperElement, {
        loop: false,
        slidesPerView: "auto",
        spaceBetween: 24,
        navigation: {
            nextEl: ".swiper-button-next"
        },
        watchSlidesVisibility: true,
        breakpointsInverse: true,
        on: swiperEvents
    });

    let storyDetailSwiper = new Swiper(storyDetailSwiperElement, {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 24,
        navigation: {
            nextEl: ".swiper-button-next"
        },
        watchSlidesVisibility: true,
        breakpointsInverse: true,
        on: swiperEvents
    });

    let aboutDetailSwiper = new Swiper(aboutSwiperElement, {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 24,
        navigation: {
            nextEl: ".swiper-button-next"
        },
        watchSlidesVisibility: true,
        breakpointsInverse: true,
        on: swiperEvents
    });

    let productDetailSwiper = new Swiper(relatedProductsSwiperElement, {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 79,
        navigation: {
            nextEl: ".swiper-button-next"
        },
        watchSlidesVisibility: true,
        breakpointsInverse: true,
        on: swiperEvents
    });

    let productGallerySwiper = new Swiper(productGallerySwiperElement, {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 26,
        navigation: {
            nextEl: ".swiper-button-next"
        },
        watchSlidesVisibility: true,
        breakpointsInverse: true,
        on: swiperEvents
    });

    const gallerySliders = Array.from(document.querySelectorAll(".gallery-slider"));
    console.log("gallerySliders", gallerySliders);
    gallerySliders.forEach((el) => {
        console.log("el", el);
        var slider = new Swiper(el, {
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 24,
            navigation: {
                nextEl: ".swiper-button-next"
            },
            watchSlidesVisibility: true,
            breakpointsInverse: true,
            on: swiperEvents
        });
    });
    
}
